import {computed, inject, Injectable, signal} from '@angular/core';
import {ApiService} from './api.service';
import {catchError, EMPTY, tap} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {Router} from '@angular/router';
import {AUTH_KEYS} from './auth-constants';
import {LoadingService} from './loading.service';

interface IUser {
}

@Injectable({providedIn: 'root'})
export class AuthService {
  apiService = inject(ApiService);
  loadingService = inject(LoadingService);
  router = inject(Router)
  private userSignal = signal<any>(null);
  user = computed(() => this.userSignal());

  constructor() {
    console.log("start auth service")
  }

  Register(data: any) {
    return this.apiService.SendPost('/auth/register', data, this.loadingService.StatesNames.REGISTER).pipe(
      tap((res) => {
        localStorage.setItem(AUTH_KEYS.ACCESS_TOKEN, res[AUTH_KEYS.ACCESS_TOKEN]);
        localStorage.setItem(AUTH_KEYS.REFRESH_TOKEN, res[AUTH_KEYS.REFRESH_TOKEN]);
        this.userSignal.set(data);
      })
    )
  }

  HasTokens() {
/*    console.log('Stored Access Token:', localStorage.getItem(AUTH_KEYS.ACCESS_TOKEN));
    console.log('Stored Refresh Token:', localStorage.getItem(AUTH_KEYS.REFRESH_TOKEN));*/
    return localStorage.getItem(AUTH_KEYS.ACCESS_TOKEN) && localStorage.getItem(AUTH_KEYS.REFRESH_TOKEN)
  }

  RequestPassword(data: any) {
    return this.apiService.SendPost('/auth/request-reset', data, this.loadingService.StatesNames.REQUEST_PASSWORD).pipe(
      tap((res) => {
      })
    )
  }

  RestorePassword(data: any) {
    return this.apiService.SendPost('/auth/reset-password', data, this.loadingService.StatesNames.RESTORE_PASSWORD).pipe(
      tap((res) => {
      })
    )
  }

  Login(data: any) {
    return this.apiService.SendPost('/auth', data, this.loadingService.StatesNames.LOGIN).pipe(
      tap((res) => {
        localStorage.setItem(AUTH_KEYS.ACCESS_TOKEN, res[AUTH_KEYS.ACCESS_TOKEN]);
        localStorage.setItem(AUTH_KEYS.REFRESH_TOKEN, res[AUTH_KEYS.REFRESH_TOKEN]);
        this.userSignal.set(res['user']);
      })
    );
  }

  GetMe() {
    return this.apiService.SendGet('/auth/me')
      .pipe(
        catchError((err) => {
          this.router.navigate(['/auth'])
          return EMPTY;
        }),
        tap((res) => {
            this.userSignal.set(res);
            if (window.location.href.includes('auth')) {
              this.router.navigate(['/base'])
            }
          }
        )
      )
  }

  RefreshToken() {
    return this.apiService.SendPost('/auth/refresh', {}).pipe(tap((res) => {
      localStorage.setItem(AUTH_KEYS.ACCESS_TOKEN, res['token']);
      localStorage.setItem(AUTH_KEYS.REFRESH_TOKEN, res['refresh']);
      this.userSignal.set(res['data']);
    }))
  }


  CLearSession() {
    localStorage.removeItem(AUTH_KEYS.ACCESS_TOKEN);
    localStorage.removeItem(AUTH_KEYS.REFRESH_TOKEN);
    this.userSignal.set(null);
  }

  logout() {
    return this.apiService.SendPost('/auth/logout', {}).pipe(
      tap(() => {
        this.CLearSession();
        this.router.navigate(['/auth']);
      })
    )
  }

  updateUser(partialUser: Partial<any>) {
    this.userSignal.set({
      ...this.userSignal(),
      ...partialUser
    });
  }
}
